module.exports = __webpack_public_path__ + "static/media/sls.f98bc0a9.svg";